module.exports = __webpack_public_path__ + "img/2.fdb15632.jpeg";